var map = {
	"./about_logo": 317,
	"./about_logo.png": 317,
	"./admin/4pt-logo": 318,
	"./admin/4pt-logo.png": 318,
	"./admin/auth-bg": 319,
	"./admin/auth-bg.jpg": 319,
	"./admin/calendar": 320,
	"./admin/calendar.svg": 320,
	"./admin/eye": 321,
	"./admin/eye.svg": 321,
	"./admin/icons/article": 322,
	"./admin/icons/article.svg": 322,
	"./admin/icons/banner": 323,
	"./admin/icons/banner.svg": 323,
	"./admin/icons/cart": 324,
	"./admin/icons/cart.svg": 324,
	"./admin/icons/contact": 325,
	"./admin/icons/contact.svg": 325,
	"./admin/icons/default": 326,
	"./admin/icons/default.svg": 326,
	"./admin/icons/faq": 327,
	"./admin/icons/faq.svg": 327,
	"./admin/icons/home": 328,
	"./admin/icons/home.svg": 328,
	"./admin/icons/member": 329,
	"./admin/icons/member.svg": 329,
	"./admin/icons/setting": 330,
	"./admin/icons/setting.svg": 330,
	"./admin/pen": 331,
	"./admin/pen.svg": 331,
	"./admin/pen_w": 332,
	"./admin/pen_w.svg": 332,
	"./admin/photo": 333,
	"./admin/photo.svg": 333,
	"./admin/return": 334,
	"./admin/return.svg": 334,
	"./admin/search": 335,
	"./admin/search.svg": 335,
	"./admin/trash": 336,
	"./admin/trash.svg": 336,
	"./arrow": 337,
	"./arrow.svg": 337,
	"./daodi-logo": 287,
	"./daodi-logo.jpg": 396,
	"./daodi-logo.png": 287,
	"./daodi-logo.svg": 397,
	"./facebook": 338,
	"./facebook.svg": 338,
	"./footer_logo": 339,
	"./footer_logo.png": 339,
	"./instant": 340,
	"./instant.svg": 340,
	"./partner/pic_1": 341,
	"./partner/pic_1.png": 341,
	"./partner/pic_1@2x": 342,
	"./partner/pic_1@2x.png": 342,
	"./partner/pic_2": 343,
	"./partner/pic_2.png": 343,
	"./partner/pic_2@2x": 344,
	"./partner/pic_2@2x.png": 344,
	"./partner/pic_3": 345,
	"./partner/pic_3.png": 345,
	"./partner/pic_3@2x": 346,
	"./partner/pic_3@2x.png": 346,
	"./partner/pic_4": 347,
	"./partner/pic_4.png": 347,
	"./partner/pic_4@2x": 348,
	"./partner/pic_4@2x.png": 348,
	"./partner/pic_5": 349,
	"./partner/pic_5.png": 349,
	"./partner/pic_5@2x": 350,
	"./partner/pic_5@2x.png": 350,
	"./partner/pic_6": 351,
	"./partner/pic_6.png": 351,
	"./partner/pic_6@2x": 352,
	"./partner/pic_6@2x.png": 352,
	"./partner/pic_7": 353,
	"./partner/pic_7.png": 353,
	"./partner/pic_7@2x": 354,
	"./partner/pic_7@2x.png": 354,
	"./prize_icon": 355,
	"./prize_icon.svg": 355,
	"./sponsors/sponsor-01": 356,
	"./sponsors/sponsor-01.png": 356,
	"./sponsors/sponsor-01@2x": 357,
	"./sponsors/sponsor-01@2x.png": 357,
	"./sponsors/sponsor-02": 358,
	"./sponsors/sponsor-02.png": 358,
	"./sponsors/sponsor-02@2x": 359,
	"./sponsors/sponsor-02@2x.png": 359,
	"./sponsors/sponsor-03": 360,
	"./sponsors/sponsor-03.png": 360,
	"./sponsors/sponsor-03@2x": 361,
	"./sponsors/sponsor-03@2x.png": 361,
	"./sponsors/sponsor-04": 362,
	"./sponsors/sponsor-04.png": 362,
	"./sponsors/sponsor-04@2x": 363,
	"./sponsors/sponsor-04@2x.png": 363,
	"./sponsors/sponsor-05": 364,
	"./sponsors/sponsor-05.png": 364,
	"./sponsors/sponsor-05@2x": 365,
	"./sponsors/sponsor-05@2x.png": 365,
	"./world_map": 366,
	"./world_map.svg": 366,
	"./youtube": 367,
	"./youtube.svg": 367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 395;